import React from 'react';
import * as S from './estilos';

import ImgLogoProv from '../../Images/Provisorio/Logo2.png';
import ImgIcon1 from '../../Images/Icon1.png';
import ImgIcon2 from '../../Images/Icon2.png';
import ImgIcon3 from '../../Images/Icon3.png';


const Provisorio = () => {


  return (
    <>
      <div id='Home'></div>
      <S.Bgbanner>
        <div className='ForaBanner'>
          <img className='ImgLogo' src={ImgLogoProv} />
          <S.BaixoProv>
            <h1>Contato</h1>
            <a className='Tel' target='_blank' rel='noreferrer' href='https://wa.me/5511991963616'>11 99196-3616</a>
            <a className='Mail' href='mailto:contato@hugopenaegabriel.com' target='_blank' rel='noreferrer'>contato@hugopenaegabriel.com</a>
            <div className='ForaIcon'>
              <a target='_blank' rel='noreferrer' href='https://wa.me/5511991963616'>
                <img src={ImgIcon1} />
              </a>  
              <a target='_blank' rel='noreferrer' href='https://www.instagram.com/hugopenaegabriel_oficial?igsh=YXN6c3AxaDR4aGVr'>
                <img src={ImgIcon2} />
              </a>
              <img src={ImgIcon3} />
            </div>
          </S.BaixoProv>
        </div>
      </S.Bgbanner>
    </>
  );
};

export default Provisorio;
